<template>
    <div class="charts">
		<div class="charts__body chart">
			<div class="chart__item chart__item--h70">
				<chart
					:update="update"
					:updateRight="updateRight"
					:updateHeight="updateHeight">
				</chart>
			</div>
			<div class="chart__item chart__item--h30">
				<tableProfit>
				</tableProfit>
			</div>
		</div>
    </div>
</template>
<script>
import ProfitGistogramm from "../statistica/sig-year-profit-gistagram";
import ProfitTable from "../statistica/sig-year-profit";
export default {
    components: {
        'chart':ProfitGistogramm,
        'tableProfit':ProfitTable
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true}
    }
}
</script>
<style lang="less" scoped>

</style>
